export const GROSS_RENT = 'GROSS_RENT';
export const CERTIFICATION_TYPES = {
  MOVE_IN: 'MOVE_IN',
  RECERT: 'RECERT',
  INITIAL: 'INITIAL',
  INITIAL_UT: 'INITIAL_UT',
  INTERIM: 'INTERIM',
  UNIT_TRANSFER: 'UNIT_TRANSFER',
  TERMINATION: 'TERMINATION',
  MOVE_OUT: 'MOVE_OUT',
};
